<nav class="navbar navbar-expand-lg telstra-nav fixed-top" data-bs-theme="dark">
  <div class="container-fluid">
    <div class="navbar-brand d-flex align-items-center nav-brand-left">
      <img
        src="/assets/img/Telstra-Logo.png"
        class="telstra-logo me-3"
        alt="Telstra"
        width="140"
        height="38"
        decoding="async"
      />
      <a
        [routerLink]="['/']"
        class="navbar-brand nav-app-title"
        data-test="nav-brand"
        (click)="onNavLinkClick()"
        >Skills</a
      >
    </div>
    <button
      class="navbar-toggler"
      type="button"
      data-test="nav-mobile-toggle"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNavDropdown"
      aria-controls="navbarNavDropdown"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div
      class="collapse navbar-collapse"
      id="navbarNavDropdown"
      data-test="nav-collapse"
    >
      <ul class="navbar-nav align-items-center">
        <li class="nav-item" [routerLinkActive]="['link-active']">
          <a
            class="nav-link"
            [routerLink]="['/consultant/search-by-skill-or-consultant']"
            data-test="nav-people"
            (click)="onNavLinkClick()"
          >
            <fa-icon
              [icon]="faUser"
              class="navmenu-dropdown-item-icon"
            ></fa-icon>
            <span class="navmenu-heading">People</span>
          </a>
        </li>

        <li class="nav-item dropdown" [routerLinkActive]="['link-active']">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            data-test="nav-search-menu"
          >
            <fa-icon
              [icon]="faMagnifyingGlass"
              class="navmenu-dropdown-item-icon"
            ></fa-icon>
            <span class="navmenu-heading">Search</span>
          </a>
          <ul class="dropdown-menu" data-bs-theme="light">
            <li [routerLinkActive]="['link-active']">
              <a
                class="dropdown-item"
                [routerLink]="['/certifications/view']"
                data-test="nav-search-certifications"
                (click)="onNavLinkClick()"
                ><fa-icon
                  [icon]="faBookOpenReader"
                  class="navmenu-dropdown-item-icon"
                ></fa-icon
                ><span class="navmenu-dropdown-item-text"
                  >Certifications</span
                ></a
              >
            </li>
            <li [routerLinkActive]="['link-active']">
              <a
                class="dropdown-item"
                [routerLink]="['/skills', 'view']"
                data-test="nav-search-skills"
                (click)="onNavLinkClick()"
                ><fa-icon
                  [icon]="faGraduationCap"
                  class="navmenu-dropdown-item-icon"
                ></fa-icon
                ><span class="navmenu-dropdown-item-text">Skills</span></a
              >
            </li>
            <li *ngIf="isAdministrator" [routerLinkActive]="['link-active']">
              <a
                class="dropdown-item"
                [routerLink]="['/admin/cert-expiry']"
                data-test="nav-search-cert-expiry"
                (click)="onNavLinkClick()"
                ><fa-icon
                  [icon]="faBookOpenReader"
                  class="navmenu-dropdown-item-icon"
                ></fa-icon
                ><span class="navmenu-dropdown-item-text"
                  >Certification Expiry</span
                ></a
              >
            </li>
          </ul>
        </li>

        <li class="nav-item" [routerLinkActive]="['link-active']">
          <a
            class="nav-link"
            [routerLink]="['/build-team']"
            data-test="nav-build-team"
            (click)="onNavLinkClick()"
          >
            <fa-icon
              [icon]="faUserPlus"
              class="navmenu-dropdown-item-icon"
            ></fa-icon>
            <span class="navmenu-heading">Build Team</span>
          </a>
        </li>

        <li class="nav-item" [routerLinkActive]="['link-active']">
          <a
            class="nav-link"
            [routerLink]="['/consultant/profile']"
            data-test="nav-profile"
            (click)="onNavLinkClick()"
          >
            <fa-icon
              [icon]="faUser"
              class="navmenu-dropdown-item-icon"
            ></fa-icon>
            <span class="navmenu-heading">Profile</span>
          </a>
        </li>

        <li class="nav-item dropdown" [routerLinkActive]="['link-active']">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            data-test="nav-explore-menu"
          >
            <fa-icon
              [icon]="faRoad"
              class="navmenu-dropdown-item-icon"
            ></fa-icon>
            <span class="navmenu-heading">Explore</span>
          </a>
          <ul class="dropdown-menu" data-bs-theme="light">
            <li [routerLinkActive]="['link-active']">
              <a
                class="dropdown-item"
                [routerLink]="['/about']"
                data-test="nav-about-skills"
                (click)="onNavLinkClick()"
                ><fa-icon
                  [icon]="faCircleInfo"
                  class="navmenu-dropdown-item-icon"
                ></fa-icon
                ><span class="navmenu-dropdown-item-text">About Skills</span></a
              >
            </li>
            <li [routerLinkActive]="['link-active']">
              <a
                class="dropdown-item"
                [routerLink]="['/capabilitymap']"
                data-test="nav-capability-map"
                (click)="onNavLinkClick()"
                ><fa-icon
                  [icon]="faChartSimple"
                  class="navmenu-dropdown-item-icon"
                ></fa-icon
                ><span class="navmenu-dropdown-item-text"
                  >Capability Map</span
                ></a
              >
            </li>
            <li [routerLinkActive]="['link-active']">
              <a
                class="dropdown-item"
                [routerLink]="['/skills-taxonomy']"
                data-test="nav-skills-taxonomy"
                (click)="onNavLinkClick()"
                ><fa-icon
                  [icon]="faFolderTree"
                  class="navmenu-dropdown-item-icon"
                ></fa-icon
                ><span class="navmenu-dropdown-item-text"
                  >Skills Taxonomy</span
                ></a
              >
            </li>
            <li [routerLinkActive]="['link-active']">
              <a
                class="dropdown-item"
                [routerLink]="['/release-notes/view']"
                data-test="nav-release-notes"
                (click)="onNavLinkClick()"
                ><fa-icon
                  [icon]="faBookOpen"
                  class="navmenu-dropdown-item-icon"
                ></fa-icon
                ><span class="navmenu-dropdown-item-text"
                  >Release Notes</span
                ></a
              >
            </li>
          </ul>
        </li>

        <!-- Admin (role-gated, single dropdown with sections) -->
        <li
          class="nav-item dropdown"
          *ngIf="
            isAdministrator ||
            isTaxonomyAdministrator ||
            isCapabilityAdministrator
          "
          [routerLinkActive]="['link-active']"
          data-test="nav-admin"
        >
          <a
            class="nav-link dropdown-toggle"
            href="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            data-test="nav-admin-menu"
          >
            <fa-icon
              [icon]="faCog"
              class="navmenu-dropdown-item-icon"
            ></fa-icon>
            <span class="navmenu-heading">Admin</span>
          </a>
          <ul class="dropdown-menu dropdown-menu-admin" data-bs-theme="light">
            <li
              *ngIf="isTaxonomyAdministrator || isAdministrator"
              class="dropdown-header"
            >
              <fa-icon
                [icon]="faGraduationCap"
                class="navmenu-dropdown-item-icon"
              ></fa-icon>
              Skills
            </li>
            <li
              *ngIf="isTaxonomyAdministrator || isAdministrator"
              [routerLinkActive]="['link-active']"
            >
              <a
                class="dropdown-item"
                [routerLink]="['/skills/manage']"
                data-test="nav-admin-manage-skills"
                (click)="onNavLinkClick()"
                ><span class="navmenu-dropdown-item-text"
                  >Manage Skills</span
                ></a
              >
            </li>
            <li
              *ngIf="isTaxonomyAdministrator || isAdministrator"
              [routerLinkActive]="['link-active']"
            >
              <a
                class="dropdown-item"
                [routerLink]="['/skill-alias']"
                data-test="nav-admin-skill-aliases"
                (click)="onNavLinkClick()"
                ><span class="navmenu-dropdown-item-text"
                  >Skill Aliases</span
                ></a
              >
            </li>
            <li
              *ngIf="isTaxonomyAdministrator || isAdministrator"
              [routerLinkActive]="['link-active']"
            >
              <a
                class="dropdown-item"
                [routerLink]="['/skill-types']"
                data-test="nav-admin-skill-types"
                (click)="onNavLinkClick()"
                ><span class="navmenu-dropdown-item-text">Skill Types</span></a
              >
            </li>
            <li
              *ngIf="isTaxonomyAdministrator || isAdministrator"
              [routerLinkActive]="['link-active']"
            >
              <a
                class="dropdown-item"
                [routerLink]="['/certifications/manage']"
                data-test="nav-admin-manage-certifications"
                (click)="onNavLinkClick()"
                ><span class="navmenu-dropdown-item-text"
                  >Manage Certifications</span
                ></a
              >
            </li>
            <li
              *ngIf="isTaxonomyAdministrator || isAdministrator"
              [routerLinkActive]="['link-active']"
            >
              <a
                class="dropdown-item"
                [routerLink]="['/skill-groups/update']"
                data-test="nav-admin-manage-skill-groups"
                (click)="onNavLinkClick()"
                ><span class="navmenu-dropdown-item-text"
                  >Manage Skill Groups</span
                ></a
              >
            </li>
            <li *ngIf="isCapabilityAdministrator || isAdministrator">
              <hr class="dropdown-divider" />
            </li>
            <li
              *ngIf="isCapabilityAdministrator || isAdministrator"
              class="dropdown-header"
            >
              <fa-icon
                [icon]="faChartSimple"
                class="navmenu-dropdown-item-icon"
              ></fa-icon>
              Capabilities
            </li>
            <li
              *ngIf="isCapabilityAdministrator || isAdministrator"
              [routerLinkActive]="['link-active']"
            >
              <a
                class="dropdown-item"
                [routerLink]="['/capabilities/leads']"
                data-test="nav-admin-capability-leads"
                (click)="onNavLinkClick()"
                ><span class="navmenu-dropdown-item-text"
                  >Capability Leads</span
                ></a
              >
            </li>
            <li
              *ngIf="isCapabilityAdministrator || isAdministrator"
              [routerLinkActive]="['link-active']"
            >
              <a
                class="dropdown-item"
                [routerLink]="['/capabilities/update']"
                data-test="nav-admin-manage-capabilities"
                (click)="onNavLinkClick()"
                ><span class="navmenu-dropdown-item-text"
                  >Manage Capabilities</span
                ></a
              >
            </li>
            <li *ngIf="isAdministrator"><hr class="dropdown-divider" /></li>
            <li *ngIf="isAdministrator" class="dropdown-header">
              <fa-icon
                [icon]="faUser"
                class="navmenu-dropdown-item-icon"
              ></fa-icon>
              Profiles
            </li>
            <li *ngIf="isAdministrator" [routerLinkActive]="['link-active']">
              <a
                class="dropdown-item"
                [routerLink]="['/admin/active-profiles']"
                data-test="nav-admin-active-profiles"
                (click)="onNavLinkClick()"
                ><span class="navmenu-dropdown-item-text"
                  >Active Profiles</span
                ></a
              >
            </li>
            <li *ngIf="isAdministrator" [routerLinkActive]="['link-active']">
              <a
                class="dropdown-item"
                [routerLink]="['/admin/hidden-profiles']"
                data-test="nav-admin-hidden-profiles"
                (click)="onNavLinkClick()"
                ><span class="navmenu-dropdown-item-text"
                  >Hidden Profiles</span
                ></a
              >
            </li>
            <li *ngIf="isAdministrator" [routerLinkActive]="['link-active']">
              <a
                class="dropdown-item"
                [routerLink]="['/admin/duplicate-profiles']"
                data-test="nav-admin-duplicate-profiles"
                (click)="onNavLinkClick()"
                ><span class="navmenu-dropdown-item-text"
                  >Duplicate Profiles</span
                ></a
              >
            </li>
            <li *ngIf="isAdministrator" [routerLinkActive]="['link-active']">
              <a
                class="dropdown-item"
                [routerLink]="['/admin/pi-manager']"
                data-test="nav-admin-pi-manager"
                (click)="onNavLinkClick()"
                ><span class="navmenu-dropdown-item-text">PI Manager</span></a
              >
            </li>
            <li *ngIf="isAdministrator" [routerLinkActive]="['link-active']">
              <a
                class="dropdown-item"
                [routerLink]="['/admin/stale-profiles']"
                data-test="nav-admin-stale-profiles"
                (click)="onNavLinkClick()"
                ><span class="navmenu-dropdown-item-text"
                  >Stale Profiles</span
                ></a
              >
            </li>
            <li *ngIf="isAdministrator" [routerLinkActive]="['link-active']">
              <a
                class="dropdown-item"
                [routerLink]="['/admin/incomplete-profiles']"
                data-test="nav-admin-incomplete-profiles"
                (click)="onNavLinkClick()"
                ><span class="navmenu-dropdown-item-text"
                  >Incomplete Profiles</span
                ></a
              >
            </li>
            <li *ngIf="isAdministrator" [routerLinkActive]="['link-active']">
              <a
                class="dropdown-item"
                [routerLink]="['/admin/onboarding']"
                data-test="nav-admin-onboarding"
                (click)="onNavLinkClick()"
                ><span class="navmenu-dropdown-item-text">Onboarding</span></a
              >
            </li>
            <li *ngIf="isAdministrator" [routerLinkActive]="['link-active']">
              <a
                class="dropdown-item"
                [routerLink]="['/admin/azure-sync']"
                data-test="nav-admin-azure-sync"
                (click)="onNavLinkClick()"
                ><span class="navmenu-dropdown-item-text">Azure Sync</span></a
              >
            </li>
            <li *ngIf="isAdministrator"><hr class="dropdown-divider" /></li>
            <li *ngIf="isAdministrator" class="dropdown-header">
              <fa-icon
                [icon]="faChartBar"
                class="navmenu-dropdown-item-icon"
              ></fa-icon>
              Statistics
            </li>
            <li *ngIf="isAdministrator" [routerLinkActive]="['link-active']">
              <a
                class="dropdown-item"
                [routerLink]="['/skill-statistics']"
                data-test="nav-admin-skill-statistics"
                (click)="onNavLinkClick()"
                ><span class="navmenu-dropdown-item-text"
                  >Skill Statistics</span
                ></a
              >
            </li>
            <li *ngIf="isAdministrator" [routerLinkActive]="['link-active']">
              <a
                class="dropdown-item"
                [routerLink]="['/admin/search-statistics']"
                data-test="nav-admin-search-statistics"
                (click)="onNavLinkClick()"
                ><span class="navmenu-dropdown-item-text"
                  >Search Statistics</span
                ></a
              >
            </li>
            <li *ngIf="isAdministrator" [routerLinkActive]="['link-active']">
              <a
                class="dropdown-item"
                [routerLink]="['/admin/profile-statistics']"
                data-test="nav-admin-profile-statistics"
                (click)="onNavLinkClick()"
                ><span class="navmenu-dropdown-item-text"
                  >Profile Statistics</span
                ></a
              >
            </li>
            <li *ngIf="isAdministrator" [routerLinkActive]="['link-active']">
              <a
                class="dropdown-item"
                [routerLink]="['/admin/certification-statistics']"
                data-test="nav-admin-certification-statistics"
                (click)="onNavLinkClick()"
                ><span class="navmenu-dropdown-item-text"
                  >Certification Statistics</span
                ></a
              >
            </li>
            <li *ngIf="isAdministrator" [routerLinkActive]="['link-active']">
              <a
                class="dropdown-item"
                [routerLink]="['/admin/industry-statistics']"
                data-test="nav-admin-industry-statistics"
                (click)="onNavLinkClick()"
                ><span class="navmenu-dropdown-item-text"
                  >Industry Statistics</span
                ></a
              >
            </li>
            <li *ngIf="isAdministrator" [routerLinkActive]="['link-active']">
              <a
                class="dropdown-item"
                [routerLink]="['/admin/capability-statistics']"
                data-test="nav-admin-capability-statistics"
                (click)="onNavLinkClick()"
                ><span class="navmenu-dropdown-item-text"
                  >Capability Statistics</span
                ></a
              >
            </li>
            <li *ngIf="isAdministrator"><hr class="dropdown-divider" /></li>
            <li *ngIf="isAdministrator" class="dropdown-header">
              <fa-icon
                [icon]="faCog"
                class="navmenu-dropdown-item-icon"
              ></fa-icon>
              Other
            </li>
            <li *ngIf="isAdministrator" [routerLinkActive]="['link-active']">
              <a
                class="dropdown-item"
                [routerLink]="['/release-notes/add-release-notes']"
                data-test="nav-admin-add-release-notes"
                (click)="onNavLinkClick()"
                ><span class="navmenu-dropdown-item-text"
                  >Add Release Notes</span
                ></a
              >
            </li>
          </ul>
        </li>
      </ul>

      <ul class="navbar-nav ms-auto align-items-center">
        <li class="nav-item">
          <a
            class="nav-link"
            href="https://ops.tech.telstra.com"
            target="_blank"
            rel="noopener noreferrer"
            data-test="nav-feedback"
            (click)="onNavLinkClick()"
          >
            <fa-icon
              [icon]="faMessage"
              class="navmenu-dropdown-item-icon"
            ></fa-icon>
            <span class="navmenu-heading">Feedback</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
